'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var border = _ref.border,
      color = _ref.color,
      font = _ref.font,
      gutter = _ref.gutter,
      toggled = _ref.toggled,
      styles = _ref.styles;
  var colors = _ref2.colors,
      scale = _ref2.scale,
      rhythm = _ref2.rhythm,
      treatments = _ref2.treatments,
      justifyContent = _ref2.justifyContent;

  var borderStyles = border ? {
    paddingLeft: rhythm(0.5),
    borderLeft: '2px solid ' + (toggled ? colors[color] : colors.shade)
  } : {};

  var defaultStyles = {
    root: _extends({
      position: 'relative',
      paddingTop: rhythm(0.5),
      paddingBottom: rhythm(0.5)
    }, borderStyles),

    head: _extends({
      display: 'flex',
      width: '100%',
      alignItems: 'center'
    }, justifyContent('flex-start'), {
      cursor: 'pointer',
      '&:focus:after': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        boxShadow: '0 0 1rem ' + colors.shade,
        pointerEvents: 'none'
      }
    }),

    toggle: {
      flexBasis: rhythm(gutter),
      display: 'flex',
      alignItems: 'flex-start',
      flex: '0 0 ' + rhythm(1),
      fontSize: scale(-2),
      color: toggled ? colors[color] : colors.lightGrey
    },

    title: _extends({}, treatments[font]),

    body: {
      display: toggled ? 'block' : 'none',
      paddingTop: rhythm(0.5),
      paddingLeft: rhythm(gutter)
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/accordion/styles.js
// module id = 876
// module chunks = 0